import { flow, get, find } from 'lodash/fp';
import Cookies from 'js-cookie';

const setLocalStorageDimension = (dimension, value) => {
  const dimensionKey = `SELECTED_${dimension}_STORAGE_KEY`;
  const currentDimension = JSON.parse(localStorage.getItem(dimensionKey));
  const updatedDimension = { ...currentDimension, serializableValue: value };

  localStorage.setItem(dimensionKey, JSON.stringify(updatedDimension));
};

export default (item) => {
  const findProductAttributeValue = name => flow(
    get('itemProduct.attributes'),
    find({ name }),
    get('value'),
  );

  const height = findProductAttributeValue('Height')(item);
  const width = findProductAttributeValue('Width')(item);

  Cookies.set('hghtz', height, { path: '/' });
  Cookies.set('widthz', width, { path: '/' });

  setLocalStorageDimension('WIDTH', width);
  setLocalStorageDimension('HEIGHT', height);
};
